import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import CancelConditionField from 'components/Fields/CancelConditionField';
import CancelConditionsOverlapAlert from 'components/Forms/CancelConditionsOverlapAlert';
import { hasOverlapError } from 'components/Forms/CancellationConditionForm';

export function ExperienceCancelConditions({ name, currency, disabled }) {
  const { t } = useTranslation();
  const [, meta] = useField(name);

  const showOverlapAlert = hasOverlapError(
    meta.error,
    t('errors:cancelConditionsOverlap'),
  );

  return (
    <div className="w-full">
      {showOverlapAlert && (
        <div className="mb-4">
          <CancelConditionsOverlapAlert />
        </div>
      )}
      <CancelConditionField
        name={name}
        currency={currency}
        showNumberOfNights={false}
        showLine={false}
        disabled={disabled}
      />
    </div>
  );
}
